module.exports = __webpack_public_path__ + "static/media/nucleo-logo.87ac3bb5.svg";